import clsx from 'clsx';
import type { FC } from 'react';

import { BrandLogo } from '../../brand';
import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <BrandLogo size={64} className="logo" />
      <div className="text">
        <p className="title">{title}</p>
        {subTitle ? <p className="subtitle">{subTitle}</p> : null}
      </div>
    </div>
  );
};
